import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Box,
  styled,
} from '@mui/material';
import HtmlIcon from '@mui/icons-material/Html';
import Css from '@mui/icons-material/Css';
import Javascript from '@mui/icons-material/Javascript';
import AcUnit from '@mui/icons-material/AcUnit';
import Code from '@mui/icons-material/Code';
import DataUsage from '@mui/icons-material/DataUsage';
import Cloud from '@mui/icons-material/Cloud';
import BugReport from '@mui/icons-material/BugReport';
import Figma from '@mui/icons-material/Palette';
import Git from '@mui/icons-material/Hub';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

const StyledAboutSection = styled(Box)(({ theme }) => ({ 
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.background.paper, // Reverted to a solid background
}));

const AboutSection = () => {
  return (
    <StyledAboutSection>
      <Container maxWidth="md">
        <Typography variant='h3' component="h2" align='center' fontWeight="bold" gutterBottom>
          About Me
        </Typography>
        {/* Main "About Me" text section */}
        <Grid container spacing={4} sx={{ mt: 4 }}>
          <Grid item xs={12}>
            <Typography variant='body1' color='text.secondary' paragraph>
              Hi, I'm Timothy, the founder of Cloud XVII, I'm a full-stack software engineer I love to turn ideas into functional, beautiful websites.
            </Typography>
            <Typography variant='body1' color='text.secondary' paragraph>
              I am a passionate software engineer with experience in front-end and back-end devlopment. I thrive in dynamic, fast-paced environments and enjoy solving complex problems.
            </Typography>
            <Typography variant='body1' color='text.secondary' paragraph>
              With a solid foundation in data analytics, I apply my skills to real-world challenges, aiming to build impactful software that enhances users' lives.
            </Typography>
          </Grid>
        </Grid>

        {/* New, centered "Tools I Use" section */}
        <Grid container justifyContent="center" sx={{ mt: 4 }}>
          <Grid item xs={12} sm={10} md={8}>
            <Box sx={{ p: 3, border: 1, borderColor: 'divider', borderRadius: 2 }}>
              <Typography variant='h5' component="h3" gutterBottom>
                Tools I Use
              </Typography>
              <Typography variant='h6' component="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                <HtmlIcon sx={{ mr: 1 }} /> Frontend
              </Typography>
              <Typography variant='body1' color='text.secondary' paragraph>
                React, JavaScript, HTML5, CSS3
              </Typography>
              <Typography variant='h6' component="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <Code sx={{ mr: 1 }} /> Backend
              </Typography>
              <Typography variant='body1' color='text.secondary' paragraph>
                Node.js, Python, Django, PostgreSQL
              </Typography>
              <Typography variant='h6' component="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <Figma sx={{ mr: 1 }} /> Design & Other Tools
              </Typography>
              <Typography variant='body1' color='text.secondary' paragraph>
                Figma, Git, Jest, <AutoFixHighIcon sx={{ display: 'inline', ml: 0.5 }} /> Framer Motion
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </StyledAboutSection>
  );
};

export default AboutSection;


